export default {
  header: 'Ups, der opstod en uventet fejl',
  text: 'Genstart siden, eller klik på knappen „Tilbage til menu“ nedenfor.',
  button: 'Tilbage til start',
};
